import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showChannelPage } from '../actions/app-state';
import { bindAll } from '../utils/functions';

export class AlternateChannelsComponent extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    constructor(...args) {
        super(...args);
        bindAll(this, 'onChannelClick');
    }

    onChannelClick(e) {
        e.preventDefault();
        const { dispatch } = this.props;
        dispatch(showChannelPage(e.target.id));
    }

    render() {
        const { items } = this.props;

        return (
            <div className="available-channels">
                <div className="channel-list">
                    {items.map(({ channel, details }) => {
                        return (
                            <img
                                id={channel.category}
                                className="channel-icon"
                                key={channel.type}
                                onClick={this.onChannelClick}
                                src={details.icon}
                                alt={details.name}
                                srcSet={`${details.icon} 1x, ${details.icon2x} 2x`}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default connect(null, null, null, { forwardRef: true })(AlternateChannelsComponent);
